var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.61 15.641A5.007 5.007 0 0 0 11 12.573H9a5.007 5.007 0 0 0-4.61 3.068C2.923 14.182 2 12.176 2 10c0-4.337 3.663-8 8-8s8 3.663 8 8c0 2.176-.923 4.182-2.39 5.641zm-9.536 1.286A3.002 3.002 0 0 1 9 14.573h2a3.003 3.003 0 0 1 2.926 2.354A7.82 7.82 0 0 1 10 18a7.82 7.82 0 0 1-3.926-1.073zM10 0C4.579 0 0 4.579 0 10c0 3.189 1.592 6.078 4 7.924V18h.102C5.77 19.245 7.813 20 10 20s4.23-.755 5.898-2H16v-.076c2.408-1.846 4-4.734 4-7.924 0-5.421-4.579-10-10-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 10c-1.178 0-2-.822-2-2s.822-2 2-2 2 .822 2 2-.822 2-2 2zm0-6C7.72 4 6 5.72 6 8c0 2.28 1.72 4 4 4 2.28 0 4-1.72 4-4 0-2.28-1.72-4-4-4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.c95b05e54aac227a014afe4eff3d222b.svg";
export { ForwardRef as ReactComponent };